/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_DescInputs */

const en_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure MIDI settings and ADR preview for audio recording`)
};

const fr_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer les paramètres MIDI et l'aperçu ADR pour l'enregistrement audio`)
};

const de_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIDI-Einstellungen und ADR-Vorschau für die Audioaufnahme konfigurieren`)
};

const it_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura le impostazioni MIDI e l'anteprima ADR per la registrazione audio`)
};

const ru_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте параметры MIDI и предварительный просмотр ADR для аудиозаписи.`)
};

const es_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar los ajustes MIDI y la vista previa ADR para la grabación de audio`)
};

const zh_cn2_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置 MIDI 设置和 ADR 预览以进行音频录制`)
};

const ja_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ録音のMIDI設定とADRプレビューを構成する`)
};

const hi_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रिकॉर्डिंग के लिए MIDI सेटिंग्स और ADR पूर्वावलोकन को कॉन्फ़िगर करें`)
};

const pt_pt2_options_adr_desc = /** @type {(inputs: Options_Adr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure as definições MIDI e a pré-visualização ADR para gravação de áudio.`)
};

/**
* | output |
* | --- |
* | "Configure MIDI settings and ADR preview for audio recording" |
*
* @param {Options_Adr_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_desc = /** @type {((inputs?: Options_Adr_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_desc(inputs)
	if (locale === "de") return de_options_adr_desc(inputs)
	if (locale === "it") return it_options_adr_desc(inputs)
	if (locale === "ru") return ru_options_adr_desc(inputs)
	if (locale === "es") return es_options_adr_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_desc(inputs)
	if (locale === "ja") return ja_options_adr_desc(inputs)
	if (locale === "hi") return hi_options_adr_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_desc(inputs)
	return en_options_adr_desc(inputs)
});